import { Component, OnInit } from '@angular/core';
import { SMStudentinfoService } from '../../forms/school-management/transaction/studentprofile/studentprofile.service';
import { NavModalComponent } from '../../../core/component/NavModal.Component';
import { GenEnum } from '../../shared/general.enum';
import { AppConstants } from '../../../app.constant';
import * as moment from "moment";
@Component({
  selector: 'app-parentsidebar',
  templateUrl: './parentsidebar.component.html',
  styleUrls: ['./parentsidebar.component.css']
})
export class ParentsidebarComponent extends NavModalComponent<any> {
  localStorage: any;
  userObj: any;
  sutdinfo: any;
  student: any;
  fname: string;
  Gname: string;
  studentid: string;
  SMCoursestxt: any;
  SMSectionstxt: any;
  url: any;
  joiningdate: string;
  studinfo: any;
  sectionid: any;
  courseid: any;
  DOB: any;
  regdate: any;
  fathername: any;
  addressstxt: any;
  countrystxt: any;
  citystxt: any;
  emergencyno: any;
  fathermobile: any;
  mobile: any;
  studid: number;
  grno: any;

  constructor(private studentService: SMStudentinfoService) {
    super(studentService);
  }

  async ngOnInit() {
    let user = this.localStorage.get("utuser");
    this.userObj = JSON.parse(user);
    await this.getstuddtl(this.userObj.empid);
  }

  async getstuddtl(id) {

    this.studid = Number(this.localStorage.get("Studentid"));
    let url = this.localStorage.get('OnlyUrl');
    
    if (this.studid) {
      
      let dto = await this.studentService.get("", [this.studid]);
      if (dto && dto.Data) {
        
        this.fname = dto.Data.firstname ? dto.Data.firstname : "-";
        this.studentid = dto.Data.studentno ? dto.Data.studentno : "-";
        this.grno = dto.Data.grno ? dto.Data.grno : "-";
        this.SMCoursestxt = dto.Data.SMCourse.stxt ? dto.Data.SMCourse.stxt : "-";
        this.SMSectionstxt = dto.Data.SMSection.stxt ? dto.Data.SMSection.stxt : "-";
        this.fathername = dto.Data.fathername ? dto.Data.fathername : "-";
        this.DOB = moment(dto.Data.dateofbirth).format(AppConstants.settings.dateFormatforString);
        this.joiningdate = dto.Data.joiningdate ? dto.Data.joiningdate : "-";
        this.regdate = dto.Data.regdate ? dto.Data.regdate : "-";
        this.addressstxt = dto.Data.address ? dto.Data.address : "-";
        this.countrystxt = dto.Data.City.Country.countryname ? dto.Data.City.Country.countryname : '-';
        this.citystxt = dto.Data.City.citystxt ? dto.Data.City.citystxt : '-';
        this.emergencyno = dto.Data.emergencyno ? dto.Data.emergencyno : '-';
        this.fathermobile = dto.Data.fathermobile ? dto.Data.fathermobile : '-';
        this.mobile = dto.Data.mobile ? dto.Data.mobile : '-';
        let entitystxt = dto.Data.OrgLegalentity.stxt

        if (dto.Data.GNImage) {
          this.url = url + GenEnum.Image.imageUrl + dto.Data.GNImage.filename
        }

        
        // this.studinfo = { "Courseid": this.courseid, "Sectionid": this.sectionid, "Id": this.studid, "entitystxt": entitystxt };
        // this.localStorage.set("selectedEntity", JSON.stringify(dto.Data.entityid));
        // this.localStorage.set("stdinfo", JSON.stringify(this.studinfo));

      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/Parent-Portal/parentsidebar/parentsidebar.component.ts